import { render } from "./editContractComponent.vue?vue&type=template&id=4c8027a1"
import script from "./editContractComponent.vue?vue&type=script&lang=js"
export * from "./editContractComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__